import { MarketAnalsis } from "../models/marketAnalysis";
import { AnalysisDetails } from "../models/analysisDetails";
import * as moment from "moment";
import { CModelRepo } from "../cmodel.repo";

class reportSummaryController implements angular.IOnInit {
  public isLoading: boolean = false;
  public marketAnalyses: MarketAnalsis[] = [];

  public selectMarketAnalysis: MarketAnalsis;
  public selectRevision: AnalysisDetails;

  private backUpRevisionText: string;

  /** @ngInject */
  constructor(
    private cModelRepo: CModelRepo,
    private $mdDialog: angular.material.IDialogService,
    private $scope: angular.IScope,
    private notifyjs: any
  ) {}

  $onInit(): void {
    this.isLoading = true;
    this.getReportSummaries();
  }

  public getReportSummaries() {
    this.cModelRepo
      .getReportSummaries()
      .then((analyses) => {
        this.marketAnalyses = analyses;
        this.marketAnalyses.forEach((analyes) => {
          analyes.analysisDetails = analyes.analysisDetails.reverse();
        });
      })
      .catch((err) => this.notifyjs(err))
      .finally(() => (this.isLoading = false));
  }

  public newAnalystText() {
    const dialogScope = this.$scope.$new() as any;
    dialogScope.invalidDates = this.marketAnalyses.map((m) => new Date(m.date));

    this.$mdDialog
      .show({
        template:
          '<md-dialog layout-padding="5"><select-date-dialog invalid-dates="invalidDates"></select-date-dialog></md-dialog>',
        scope: dialogScope,
      })
      .then((date: Date) => {
        this.selectMarketAnalysis = <MarketAnalsis>{
          quarter: moment(date).quarter(),
          revisions: 1,
          date: date.toISOString(),
          analysisDetails: [
            <AnalysisDetails>{
              revisionNo: 1,
              marketAnalysis: "",
              marketAnalysisFrench: "",
            },
          ],
        };
        this.selectRevision = this.selectMarketAnalysis.analysisDetails[0];
      })
      .catch(() => console.log("Cancelled new dialog"));
  }

  public viewAnalysis(analysis: MarketAnalsis) {
    if (this.backUpRevisionText) {
      // Reset any change that might of happened, between changes
      this.selectMarketAnalysis.analysisDetails[0].marketAnalysis =
        this.backUpRevisionText;
    }
    this.selectMarketAnalysis = analysis;
    this.selectRevision = analysis.analysisDetails[0];
    this.backUpRevisionText = analysis.analysisDetails[0].marketAnalysis;
  }

  public onRevisionChange(revision: AnalysisDetails) {
    if (
      revision.revisionNo ===
      this.selectMarketAnalysis.analysisDetails[0].revisionNo
    ) {
      revision.marketAnalysis = this.backUpRevisionText;
    }
  }

  public formatDate(date) {
    return moment(date).fromNow();
  }

  public onLatestRevision() {
    return (
      this.selectRevision.revisionNo ===
      this.selectMarketAnalysis.analysisDetails[0].revisionNo
    );
  }

  public saveRevision() {
    this.cModelRepo
      .saveReportSummaries(this.selectMarketAnalysis)
      .then((updatedMarketAnalysis) => {
        var currentIndex = this.marketAnalyses.findIndex(
          (m) => m.date === updatedMarketAnalysis.date
        );
        if (currentIndex === -1) {
          this.marketAnalyses.push(updatedMarketAnalysis);
        } else {
          this.marketAnalyses[currentIndex] = updatedMarketAnalysis;
        }
        this.backUpRevisionText = "";
        this.getReportSummaries();
      })
      .catch((err) => this.notifyjs(err))
      .finally(() => {
        let selectedAnalysisIndex = this.marketAnalyses.findIndex(
          (ma) => ma.date === this.selectMarketAnalysis.date
        );
        if (selectedAnalysisIndex > -1) {
          this.viewAnalysis(this.marketAnalyses[selectedAnalysisIndex]);
        }
      });
  }
}

export const reportSummary: angular.IComponentOptions = {
  template: require("./reportSummary.html"),
  controller: reportSummaryController,
};



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.marketAnalysis/reportSummary.ts